// @flow
import escapeHTML from './escapeHTML';

export default function absolutizeUrl(url: string): string {
   var el = document.createElement('div');
   el.innerHTML = '<a href="' + escapeHTML(url) + '">x</a>';
   const link = el.firstChild;
   return link && link instanceof HTMLLinkElement ? link.href : url;
}
